/**
 * @file chartTooltipBuilder.ts
 *
 * @description
 * Utility functions for building CanvasJS chart tooltip HTML strings.
 * Since CanvasJS `contentFormatter` requires a raw HTML string (not JSX),
 * these pure helper functions encapsulate all tooltip markup and inline styles
 * in one place — keeping chart config files clean and the tooltip structure
 * consistent across KPI and Dual (Temperature/Humidity) charts.
 *
 * @author Chandan Singh
 * @created 2026-05-05
 */
import { formatUtcToLocal } from '../../../constants/common.constant';
import './chartToolTip.css'
const PREFIX = 'chart-tooltip';

const dot = (color: string) => `
  <span class="${PREFIX}__dot" style="--tooltip-dot-color:${color}"></span>`;

export const tooltipRow = (color: string, name: string, value: any) => `
  <div class="${PREFIX}__row">
    ${dot(color)}
    <span class="${PREFIX}__text">${name}: <b>${value ?? '—'}</b></span>
  </div>`;

export const tooltipThresholdRow = (color: string, label: string, value: any) => `
  <div class="${PREFIX}__threshold-row">
    ${dot(color)}
    <span class="${PREFIX}__label">${label}:</span>
    <span class="${PREFIX}__value">${value}</span>
  </div>`;

export const tooltipDivider = (content: string) => `
  <div class="${PREFIX}__divider">
    ${content}
  </div>`;

export const tooltipWrapper = (dateStr: string, body: string) => `
  <div class="${PREFIX}__wrapper">
    <div class="${PREFIX}__date">${dateStr}</div>
    ${body}
  </div>`;

export const tooltipSeparator = () => `
  <div class="${PREFIX}__divider"></div>`;
// {<span style="display:inline-block;width:10px;height:2px;background:#2cd6e8;flex-shrink:0"></span>}